import { INVOICES, type InvoicesAction } from '../actions/invoicesActions';

export type InvoicesState = {
  order: Object;
};

export const invoicesInitialState = {
  order: null,
};

export const invoicesReducer = (
  state = invoicesInitialState,
  action: InvoicesAction,
): InvoicesState => {
  switch (action.type) {
    case INVOICES.RECEIVE_ORDER_CONFIRMATION: {
      return {
        ...state,
        order: action.order,
      };
    }

    default: {
      return state;
    }
  }
};

export default invoicesReducer;
